import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Power = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 14C15.45 14 15 13.55 15 13V3C15 2.45 15.45 2 16 2C16.55 2 17 2.45 17 3V13C17 13.55 16.55 14 16 14Z" />
		<path d="M23.563 4.17502L23.538 4.16202C23.388 4.06202 23.201 3.99902 23 3.99902C22.45 3.99902 22 4.44902 22 4.99902C22 5.34902 22.188 5.66102 22.462 5.83702C25.924 8.06202 28 11.862 28 15.999C28 22.612 22.613 27.999 16 27.999C9.387 27.999 4 22.612 4 15.999C4 11.862 6.075 8.06102 9.537 5.83702C9.812 5.66202 10 5.35002 10 4.99902C10 4.44902 9.55 3.99902 9 3.99902C8.8 3.99902 8.625 4.06202 8.463 4.14902L8.438 4.16202C4.413 6.76202 2 11.187 2 15.999C2 23.724 8.275 29.999 16 29.999C23.725 29.999 30 23.724 30 15.999C30 11.186 27.587 6.76102 23.562 4.17402L23.563 4.17502Z" />
	</svg>
);

export default Power;
